export default "__VITE_ASSET__cdaa8f36__"